import React from 'react'
import ExperienceSection from '../components/ExperienceSection'
import ProjectsSection from '../components/ProjectsSection'
import About from '../components/Sidebar/About'
import Links from '../components/Sidebar/Links'

import './style.scss'

const IndexPage = () => (
    <div className="index">
      <div className="main">
        <h5>
          Hi, I'm <span className="bold">Deepak Mishra</span>
        </h5>

        <h3 className="bold">
            I am a Front End / JavaScript Stack Developer with over 9 years of experience.
        </h3>
        <div>
          <h4>Skills</h4>
          <ul>
          <li><strong>ReactJS</strong></li>
          <li><strong>Redux</strong></li>
          <li><strong>Node JS</strong></li>
          <li><strong>Angular JS</strong></li>
          <li><strong>JavaScript</strong></li>
          <li><strong>CSS</strong>, TypeScript, Express JS,
 Webpack, LESS, SCSS</li>
          </ul>
        </div>
        <div><Links /></div>

      </div>

      <div className="aside">
        <div className="top">
          <About />
        </div>
        <div className="bottom">
          <Links />
        </div>
      </div>
    </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js